export default __webpack_public_path__ + "static/mifuture-2-bbf3b466451e1f9289118ac999d7a2d9.jpg";